import { gql, type TypedDocumentNode } from '@apollo/client';
import { type PropsWithChildren } from 'react';

import { HeartIcon } from '@sorare/core/src/atoms/icons/HeartIcon';
import { range } from '@sorare/core/src/lib/arrays';
import type { unitMapping } from '@sorare/core/src/lib/style';

import type { Lifes_thresholdPickerTask } from './__generated__/index.graphql.ts';

type Props = {
  task: {
    maxLineupsCount: number;
    remainingLineupsCount: number;
    pendingLineupsCount: number;
  };
  size?: keyof typeof unitMapping;
};

export const Lifes = ({ task, size = 2 }: PropsWithChildren<Props>) => {
  const { maxLineupsCount, pendingLineupsCount, remainingLineupsCount } = task;

  const getStatus = (index: number) => {
    if (index < remainingLineupsCount) {
      return 'active';
    }
    if (index < pendingLineupsCount + remainingLineupsCount) {
      return 'pending';
    }
    return 'inactive';
  };
  return (
    <>
      {range(maxLineupsCount).map(i => (
        <HeartIcon key={i} status={getStatus(i)} size={size} />
      ))}
    </>
  );
};

Lifes.fragments = {
  thresholdPickerTask: gql`
    fragment Lifes_thresholdPickerTask on ThresholdPickerTask {
      id
      maxLineupsCount
      pendingLineupsCount
      remainingLineupsCount
    }
  ` as TypedDocumentNode<Lifes_thresholdPickerTask>,
};
